/**
 * Removes the "__typename" property from an object of type T, if it exists.
 *
 * @param {Type} data - The object to remove the "__typename" property from.
 * @return {Omit<Type, '__typename'>} The object with the "__typename" property removed.
 */
export function removeTypename<Type extends { __typename?: string }>(data: Type): Omit<Type, '__typename'> {
  return '__typename' in data ? { ...data, __typename: undefined } : data;
}
